"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const hooks_1 = require("../../../../../hooks");
const formik_1 = require("formik");
const ContentFeedCanvasForm_1 = require("./ContentFeedCanvasForm");
const constants_1 = require("./constants");
const onSubmit_1 = require("./onSubmit");
const contentFeedInitialValues_1 = require("./contentFeedInitialValues");
const OsmosysResourceCard_1 = require("./OsmosysResourceCard");
exports.ContentFeedCanvas = ({ integration, }) => {
    var _a;
    const { match } = use_react_router_1.default();
    const { data, loading, error } = hooks_1.useContentFeedQuery({
        variables: {
            id: match.params.contentFeedId,
        },
    });
    const contentFeed = (_a = data) === null || _a === void 0 ? void 0 : _a.contentFeed;
    const { update, updateResult } = hooks_1.useUpdateContentFeedMutation({});
    if (!contentFeed) {
        if (loading) {
            return react_1.default.createElement(react_2.OsmosysLoadingState, null);
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysUndesiredState, { message: "There was a problem loading this content feed", level: "danger", error: error })));
    }
    return (react_1.default.createElement(formik_1.Formik, { initialValues: contentFeedInitialValues_1.contentFeedInitialValues(contentFeed), onSubmit: onSubmit_1.onSubmit(update, contentFeed), validationSchema: constants_1.CONTENT_FEED_YUP_SCHEMA }, formikProps => {
        return (react_1.default.createElement(OsmosysResourceCard_1.OsmosysResourceCard, null,
            react_1.default.createElement(ContentFeedCanvasForm_1.ContentFeedCanvasForm, { contentFeed: contentFeed, formikProps: formikProps, cms: integration, updateResult: updateResult })));
    }));
};
//# sourceMappingURL=index.js.map